import Dropdown from 'components/ui/dropdown/Dropdown';
import { global_hooks } from 'src/globals';

global_hooks.on('listing/init', init);

function init(listing) {
	if (!listing.args.sort) return;

	let apply_sort = false;

	const sort_args = {
		key: null,
		order: null,
	};

	let items = listing.items;

	listing.hooks.on('filter/result', (result) => {
		items = result;
		console.log('filter/result', { result, sort_args });
	});

	const dropdown = new Dropdown(listing.args.sort, {
		raw: true,
	});

	const handle_select = (option) => {
		sort_args.key = option.dataset.sort_key;
		sort_args.order = option.dataset.sort_order;

		const loading = listing.loading();

		const result = get_result(items, sort_args);

		loading.end(() => {
			listing.hooks.do('result/render', result);
		});
	};

	dropdown.hooks.on('select', handle_select);

	// listing.hooks.on('render_result/before', (result) => {
	// 	if (!sort_args.key && !sort_args.reset) return;
	// 	console.log('apply_sort', result);
	// 	result.forEach((i) => {
	// 		if (!i.el) return;
	// 		listing.container.append(i.el);
	// 	});
	// 	sort_args.reset = false;
	// });
}

function get_result(items, sort_args) {
	const { key, order } = sort_args;
	if (!key) return items;

	let result = [...items];

	result.sort((a, b) => {
		if (order === 'asc') {
			if (a.data[key] < b.data[key]) return -1;
			if (a.data[key] > b.data[key]) return 1;
		} else if (order === 'desc') {
			if (a.data[key] < b.data[key]) return 1;
			if (a.data[key] > b.data[key]) return -1;
		}
		return 0;
	});

	return result;
}
